// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leave-report-containers {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  padding: 25px;
  background-color: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  max-width: 950px;
  position: relative;
  height: 100%;
  overflow: scroll;
}

.leave-report-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0px;
  margin-top: -24px;
}

.info-text {
  font-size: 14px;
  background-color: #f4f4f4;
  padding: 10px;
  border-left: 4px solid #ffc107;
  margin-bottom: 20px;
  line-height: 1.5;
}

.leave-report-form {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  flex-wrap: wrap;
}

.form_section {
  flex: 1 1;
  min-width: 250px;
}

.form_section label {
  display: block;
  margin-bottom: 5px;
  /* font-size: 14px; */
}

.form_section select {
  width: 100%;
  padding: 7px;
  margin-top: 2px;
}

.required {
  color: red;
  margin-right: 5px;
}
.leave_checkbox_section {
  display: flex;

  gap: 10px;
  height: 28px;
  margin-left: 0px;
  width: 44%;
  /* border: 1px solid black; */
}
.leave_checkbox_section label {
  width: 500px;
  /* border: 1px solid black; */
  margin-top: 7px;
  height: 26px;
}
.checkbox-wrapper {
  margin-top: 10px;
  font-size: 14px;
}
.all_employe_check {
  margin-top: 10px;
  width: 14%;
}

.leave-types {
  flex: 1 1;
  min-width: 250px;
  width: 100%;
}

.leave-types table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 28px;
  cursor: pointer;
}

.leave-types th,
.leave-types td {
  padding: 8px 10px;
  border: 1px solid #ddd;
  font-size: 14px;
}
.input_leave_balence {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Karla", sans-serif;
  cursor: pointer;
}
.leave-types tbody tr:nth-child(odd) {
  /* border: 1px solid #000; */
  background-color: #f2eeee37;
}

.view_button_of_balence {
  margin-top: 10px;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.Download-button {
  /* padding: 8px 20px;
  background-color: #e5e0dd; */
  border: none;
  cursor: pointer;
  font-weight: bold;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
}

@media screen and (min-width: 1025px) and (max-width: 1440px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/ReportsComponent/LeaveBalance.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;;EAEb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;8BAC4B;EAC5B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".leave-report-containers {\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  padding: 25px;\n  background-color: #f8f9fa;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  max-width: 950px;\n  position: relative;\n  height: 100%;\n  overflow: scroll;\n}\n\n.leave-report-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 0px;\n  margin-top: -24px;\n}\n\n.info-text {\n  font-size: 14px;\n  background-color: #f4f4f4;\n  padding: 10px;\n  border-left: 4px solid #ffc107;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.leave-report-form {\n  display: flex;\n  justify-content: space-between;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.form_section {\n  flex: 1;\n  min-width: 250px;\n}\n\n.form_section label {\n  display: block;\n  margin-bottom: 5px;\n  /* font-size: 14px; */\n}\n\n.form_section select {\n  width: 100%;\n  padding: 7px;\n  margin-top: 2px;\n}\n\n.required {\n  color: red;\n  margin-right: 5px;\n}\n.leave_checkbox_section {\n  display: flex;\n\n  gap: 10px;\n  height: 28px;\n  margin-left: 0px;\n  width: 44%;\n  /* border: 1px solid black; */\n}\n.leave_checkbox_section label {\n  width: 500px;\n  /* border: 1px solid black; */\n  margin-top: 7px;\n  height: 26px;\n}\n.checkbox-wrapper {\n  margin-top: 10px;\n  font-size: 14px;\n}\n.all_employe_check {\n  margin-top: 10px;\n  width: 14%;\n}\n\n.leave-types {\n  flex: 1;\n  min-width: 250px;\n  width: 100%;\n}\n\n.leave-types table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 28px;\n  cursor: pointer;\n}\n\n.leave-types th,\n.leave-types td {\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  font-size: 14px;\n}\n.input_leave_balence {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: \"Karla\", sans-serif;\n  cursor: pointer;\n}\n.leave-types tbody tr:nth-child(odd) {\n  /* border: 1px solid #000; */\n  background-color: #f2eeee37;\n}\n\n.view_button_of_balence {\n  margin-top: 10px;\n}\n\n.report-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.Download-button {\n  /* padding: 8px 20px;\n  background-color: #e5e0dd; */\n  border: none;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n}\n\n@media screen and (min-width: 1025px) and (max-width: 1440px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
